import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import api from "../../../Component/axios_Interceptor/api";
import api2 from "../../../Component/axios_Interceptor/api2";
import url from "../../../Component/server";
import { fontStyles } from "../../../Component/style/common_font";
import Layout_Admin from "../../../Component/UI/Layout_Admin";
import { amountFormat } from "../../../Component/tool/Tools";
import { CenterView, RowView } from "../../../Component/style/common_style";
import PagingControl from "../../../Component/UI/PagingControl";
import CoinChargeModal from "./Modal/CoinChargeModal";
import CompleteModal from "./Modal/CompleteModal";

interface listData {
  log_type: string;
  log_dt: string;
  log_con: string;
  coin: number;
  r_coin: number;
  coin_check: string;
  seq: number;
}

const CoinManage = () => {
  const [reload, setReload] = useState(false);
  const [myCoin, setMyCoin] = useState(0);
  const [select, setSelect] = useState("전체");
  const handleSelect = (data: string) => {
    setSelect(data);
  };
  const [cnt, setCnt] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [list, setList] = useState<listData[]>([]);

  // 충전 모달
  const [visible, setVisible] = useState(false);
  const handleModal = () => {
    setVisible(!visible);
  };

  // 입금정보 모달
  const [completeVisible, setCompleteVisible] = useState(false);
  const handleCompleteModal = () => {
    setCompleteVisible(!completeVisible);
  };
  const [selectNum, setSelectNum] = useState(0);

  // 보유 코인 조회
  const stock_coin = async () => {
    try {
      const res = await api.get(url.Communication_url.stock_coin);
      setMyCoin(res.data.coin);
    } catch (error) {
      console.error("코인 재고 조회 실패:", error);
    }
  };

  // 코인 내역 조회
  const coin_log_list = async () => {
    try {
      const res = await api.get(url.Communication_url.coin_log_list, {
        params: {
          current_page: currentPage,
          per_page: 20,
          log_type: select === "전체" ? "" : select,
        },
      });
      setList(res.data.coinLogList);
    } catch (error) {}
  };

  const coin_charging_cancel = async (seq: number) => {
    try {
      const res = await api.post(url.Communication_url.coin_charging_cancel, {
        seq: seq,
      });
      if (res.data === "성공") {
        handleReload();
      }
    } catch (error) {
      console.error("코인 충전 취소 실패:", error);
    }
  };

  useEffect(() => {
    stock_coin();
    coin_log_list();
  }, [reload]);

  const handleReload = () => {
    setReload(!reload);
  };

  return (
    <Layout_Admin menuname={"코인 관리"}>
      <TitleArea>코인 관리</TitleArea>
      <MyCoinDiv>
        보유 코인
        <div className="blue">{amountFormat(myCoin)}C</div>
      </MyCoinDiv>
      <RowView>
        <CateDiv>
          <Cate
            $select={select === "전체"}
            onClick={() => handleSelect("전체")}
          >
            전체
          </Cate>
          <Cate
            $select={select === "충전"}
            onClick={() => handleSelect("충전")}
          >
            충전
          </Cate>
          <Cate
            $select={select === "사용"}
            onClick={() => handleSelect("사용")}
          >
            사용
          </Cate>
          <Cate
            $select={select === "환불"}
            onClick={() => handleSelect("환불")}
          >
            환불
          </Cate>
        </CateDiv>
        <CoinChargeBtn onClick={handleModal}>코인 충전하기</CoinChargeBtn>
      </RowView>
      <Table className="header" style={{ marginTop: 16 }}>
        <Row>구분</Row>
        <Row className="flex2">일시</Row>
        <Row className="flex4">내역</Row>
        <Row className="flex2">포인트</Row>
        <Row className="flex2">잔여 포인트</Row>
        <Row className="flex4"></Row>
      </Table>
      {list.map((data, index) => {
        return (
          <Table key={index}>
            <Row>{data.log_type}</Row>
            <Row className="flex2">{data.log_dt}</Row>
            <Row
              className="flex4"
              $gray={
                data.log_con === "코인 충전 입금 대기" ||
                data.log_con === "코인 충전 취소"
              }
            >
              {data.log_con}
            </Row>
            <Row className="flex2" $log_type={data.log_type}>
              {data.log_con !== "코인 충전 입금 대기" &&
                data.log_con !== "코인 충전 취소" && (
                  <>
                    {data.log_type === "사용" ? "-" : "+"}
                    {amountFormat(data.coin)}
                  </>
                )}
            </Row>
            <Row className="flex2">
              {data.log_con !== "코인 충전 입금 대기" &&
                data.log_con !== "코인 충전 취소" &&
                amountFormat(data.r_coin)}
            </Row>
            <Row className="btn">
              {data.log_type === "충전" &&
                data.log_con === "코인 충전 입금 대기" &&
                data.coin_check !== "c" && (
                  <InfoBtn
                    onClick={() => {
                      handleCompleteModal();
                      setSelectNum(index);
                    }}
                  >
                    입금정보
                  </InfoBtn>
                )}
              {data.log_type === "충전" &&
                data.log_con === "코인 충전 입금 대기" &&
                data.coin_check === "n" && (
                  <CancelBtn onClick={() => coin_charging_cancel(data.seq)}>
                    취소
                  </CancelBtn>
                )}
            </Row>
          </Table>
        );
      })}

      <PagingControl
        cnt={cnt}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
      <CoinChargeModal
        visible={visible}
        handleModal={handleModal}
        myCoin={myCoin}
        handleReload={handleReload}
      />
      <CompleteModal
        visible={completeVisible}
        handleModal={handleCompleteModal}
        chargeCoin={list.length > 0 ? list[selectNum].coin : 0}
        myCoin={myCoin}
      />
    </Layout_Admin>
  );
};

export default CoinManage;

const TitleArea = styled.div`
  margin-bottom: 1rem;
  ${fontStyles.Bold}
  font-size: 20px;
`;

const MyCoinDiv = styled.div`
  padding: 24px 24px;
  margin-top: 24px;
  border-radius: 8px;
  width: 280px;
  background-color: #ede8ff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  .blue {
    color: #3209b9;
    font-family: var(--font-Pretendard-SemiBold);
    font-size: 22px;
  }
`;

const CateDiv = styled.div`
  gap: 8px;
  margin-top: 30px;
  flex-direction: row;
  display: flex;
`;

const Cate = styled.div<{ $select: boolean }>`
  border-radius: 24px;
  border: ${(props) =>
    props.$select ? "1px solid black" : "1px solid #E8E8E8"};
  background-color: ${(props) => (props.$select ? "black" : "white")};
  color: ${(props) => (props.$select ? "white" : "#8E8E8E")};
  width: 60px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const CoinChargeBtn = styled.div`
  border-radius: 8px;
  width: 138px;
  height: 40px;
  background: linear-gradient(135deg, #7955f0, #3209b9);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-family: var(--font-Pretendard-Medium);
  cursor: pointer;
`;

const Table = styled(RowView)`
  min-height: 4rem;
  border-bottom: 2px solid #f8f8f8;
  overflow: hidden;
  &.header {
    min-height: 3rem;
    ${fontStyles.medium}
    background-color: #f8f8f8;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

const Row = styled(CenterView)<{ $log_type?: string; $gray?: boolean }>`
  flex: 1;
  margin: 0px 0.5rem;
  max-height: 2.4rem;
  text-align: center;
  font-family: var(--font-Pretendard-Medium);
  div {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &.flex4 {
    flex: 4;
    color: ${(props) => (props.$gray ? "#8E8E8E" : "#010101")};
  }
  &.flex2 {
    flex: 2;
    color: ${(props) =>
      props.$log_type === "사용"
        ? "#EB003B"
        : props.$log_type === "충전" || props.$log_type === "환불"
        ? "#2768FF"
        : "#010101"};
  }
  &.btn {
    flex: 4;
    justify-content: flex-start;
    gap: 8px;
  }
`;

const InfoBtn = styled.div`
  width: 74px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #f0f0f0;
  line-height: 32px;
  cursor: pointer;
`;

const CancelBtn = styled.div`
  width: 50px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #f0f0f0;
  color: #8e8e8e;
  line-height: 32px;
  cursor: pointer;
`;
